import React from 'react';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import { themeColor } from '../../Theming';

const Container = styled.div`
  padding-inline: 24px;
  padding-top: 24px;
`;

const Title = styled.h2`
  font-family: Helvetica;
  line-height: 30px;
  display: flex;
  font-size: 24px;
  color: ${themeColor('navyBlueText')};
  margin: 0;
`;

const Msg = styled.p`
  line-height: 20px;
  display: flex;
  margin: 0;
  font-size: 18px;
  color: ${themeColor('navyBlueText')};
  font-family: Helvetica;
`;

const StepsContainer = styled.ol`
  padding-top: 30px;
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0;
  margin: 0;
`;

const StepItem = styled.li`
  display: flex;
  flex-direction: row;
  list-style-type: none;
  &:not(:last-child) {
    padding-bottom: 10px;
  }
`;

const StepTag = styled.div`
  height: 20px;
  width: 20px;
  padding-top: 2px;
  border-radius: 20px;
  margin-top: 2.5px;
  font-weight: Bold;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Helvetica;
  background-color: #925bfb;
  color: ${themeColor('white')};
`;

const StepText = styled.p`
  margin: 0 0 0 10px;
  font-family: Helvetica;
`;

interface ActivationStepsProps {
  steps?: string[];
  title?: string;
  msg?: string;
}

const ActivationSteps: React.FC<ActivationStepsProps> = ({
  steps,
  title,
  msg,
}) => {
  return (
    <Container>
      <Title>{title}</Title>
      <Msg>{msg}</Msg>
      <StepsContainer>
        {steps?.map((item, index) => (
          <StepItem key={index}>
            <StepTag>{index + 1}</StepTag>
            <Trans>
              <StepText>{item}</StepText>
            </Trans>
          </StepItem>
        ))}
      </StepsContainer>
    </Container>
  );
};

export default ActivationSteps;
